import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NbCardModule } from '@nebular/theme';
import { NgSelectModule } from '@ng-select/ng-select';//https://github.com/ng-select/ng-select
import { ProcessModalComponent } from './process-modal.component'
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NgSelectModule,
  ],
  declarations: [
    ProcessModalComponent
  ]
})
export class ProcessModalModule { }



// WEBPACK FOOTER //
// ./src/app/pages/process/modal/process-modal.module.ts